var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCloseTr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99031 5.57585C6.59979 5.18533 5.96662 5.18533 5.5761 5.57585C5.18557 5.96638 5.18557 6.59954 5.5761 6.99007L10.5259 11.9398L5.57612 16.8896C5.1856 17.2801 5.1856 17.9132 5.57612 18.3038C5.96664 18.6943 6.59981 18.6943 6.99033 18.3038L11.9401 13.354L16.8898 18.3038C17.2803 18.6943 17.9135 18.6943 18.304 18.3038C18.6945 17.9132 18.6945 17.2801 18.304 16.8896L13.3543 11.9398L18.304 6.99007C18.6946 6.59954 18.6946 5.96638 18.304 5.57585C17.9135 5.18533 17.2804 5.18533 16.8898 5.57585L11.9401 10.5256L6.99031 5.57585Z",
    fill: "#F7E4FB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseTr);
export default __webpack_public_path__ + "static/media/icon-close-tr.c87db8660ae96eb3ce76506cb4f703d3.svg";
export { ForwardRef as ReactComponent };